import React, { FC } from 'react';
import { H3 } from '../../components/H3';

export const ExchangePage = () => {
  return (
    <>
      <div className="max-w-screen-md mx-auto flex flex-col items-center justify-center space-y-8 text-cente">
        <H3 className="font-semibold">EXCHANGE & RETURN</H3>

        <div className="text-12 flex flex-col space-y-8">
          <p className="flex flex-col ">
            <span className="font-bold"> 1. 교환/환불 규정</span>
            상품 수령 시 상품 관리 부주의로 인하여 판매 가치가 훼손 된 상품은
            교환 및 환불이 불가능합니다.
            <br />
            <br />* 상품 수령 시 반드시 상품의 하자 여부를 확인 부탁드립니다.
            상품 하자 여부의 확인이 없이 반품 된 제품은 고객님의 책임 사유가 될
            수 있습니다. <br />* 착용한 흔적이 있는 제품의 경우 구매 후 이상이
            없음을 확인 한 뒤 사용하신 것으로 간주하여 이에 따른 교환 및 환불은
            불가하며 공정거래위원회 고시 소비자분쟁해결기준에 의거 A/S로 진행될
            수 있습니다.
            <br />
            <br />
            <InfoItem
              bullet="(1)"
              content="교환/환불의 경우 모든 상품은 상품을 공급받으신 날로부터 7일 이내
                신청 및 택배 접수를 해주셔야 가능합니다. * 제품이 본사로 도착
                후, 교환/반품 기간 이내에 배송비 및 추가 비용이 해당 계좌로
                입금이 안 될 경우 상품이 재 반송됩니다."
            />
            <InfoItem
              bullet="(2)"
              content=" 상품을 미사용한 상태에서 택을 제거하지 않고 반송하여 주십시오."
            />
            <InfoItem
              bullet="(3)"
              content="본사에 반송된 상품의 입고 여부가 확인된 후에 검품을 거쳐 환불하여 드립니다.
              (검수 시 상품의 오염/이염 혹은 상품의 가치가 떨어져 재판매가 불가능한 경우에는 교환 및 환불이 어렵습니다. 상품 수령 시 필히 상품 확인을 부탁드립니다.)
             "
            />
            <InfoItem
              bullet="(4)"
              content="고객님의 단순 변심으로 인한 상품의 교환/반품을 요청하시는 경우, 택배비용은 고객님 부담이오니 이점 양해 바랍니다.

             "
            />
            <InfoItem
              bullet="(5)"
              content="공급 받은 상품 내용이 다르게 이행된 경우 (상품불량 등), 공급 받은 날로부터 3개월 이내, 그 사실을 알게 된 날 또는 알 수 있었던 날로부터 30일 이내에 교환/반품 신청이 가능합니다.
             "
            />
            <InfoItem
              bullet="(6)"
              content="전자상거래 등에서의 소비자보호에 관한 법률 제17조 (청약철회 등) 에 의거 상품의 반품이 불가능한 경우 교환 및 반품이 되지 않습니다.
             "
            />
            <div className="pl-6 pt-4">
              <InfoItem
                bullet="(a)"
                content={`고객님의 책임 있는 사유로 상품 등이 멸실 또는 훼손된 경우.
                (단, 상품의 내용을 확인하기 위하여 포장 등을 훼손한 경우는 제외)`}
              />
              <InfoItem
                bullet="(b)"
                content={`포장을 개봉하였거나 포장이 훼손되어 상품가치가 현저히 상실된 경우`}
              />
              <InfoItem
                bullet="(c)"
                content={`모든 상품의 Tag, 상품스티커, 비닐포장, 상품케이스(정품박스) 등을 훼손 및 멸실한 경우`}
              />
              <InfoItem
                bullet="(d)"
                content={`시간의 경과에 의하여 재판매가 곤란할 정도로 상품 등의 가치가 현저히 감소한 경우`}
              />
              <InfoItem
                bullet="(e)"
                content={`구매하신 상품의 구성(사은)품이 누락된 경우 (단, 그 구성품이 훼손 없이 회수가 가능한 경우 제외)`}
              />
              <InfoItem
                bullet="(f)"
                content={`구매 이후 세탁 및 수선으로 인하여 상품이 훼손 된 경우`}
              />
            </div>
          </p>

          <p className="flex flex-col ">
            <span className="font-bold"> 2. 신청 방법</span>
            당일 출고된 상품의 경우 당일 저녁에 해당 택배사로 상품이 인계됩니다.
            <br />
            상품이 택배사로 전달되면 배송업체 시스템에 운송장번호가 등록되므로
            익일 오전부터 배송조회가 가능합니다.
            <InfoItem
              className="pt-4"
              bullet="(1)"
              content={` 회원 구매: 로그인 > 마이페이지 > 주문내역 > 주문서 상세 페이지 조회 > 교환/환불 신청`}
            />
            <InfoItem
              bullet="(2)"
              content={`비회원 구매: LOG-IN > 비회원주문확인 > 주문내역 > 주문서 상세 페이지 조회 > 교환/환불 신청`}
            />
          </p>

          <p className="flex flex-col ">
            <span className="font-bold"> 3. 환불 소요 기간</span>
            고객님께서 반품 택배 발송 후 상품이 저희 쪽으로 입고되면, 상품 검수
            후 이상이 없는 경우 환불이 진행됩니다. (토,일,공휴일은 제외)
            <InfoItem
              className="pt-4"
              bullet="(1)"
              content={`가상계좌: 가상 계좌 환불 시, (공휴일 제외) 익일 해당 계좌로 환불 됩니다. (두 상품 이상 반품 시 각각 하루에 걸쳐 해당 계좌로 환불됩니다.)`}
            />
            <InfoItem
              bullet="(2)"
              content={`실시간 계좌 이체: 은행 영업 일에 따라 약 3~5일 후 해당 계좌로 입금됩니다.`}
            />
            <InfoItem
              bullet="(3)"
              content={`신용카드: 카드사 및 은행사 사정에 따라 취소 기간이 3~5일 정도 소요됩니다.`}
            />
            <InfoItem
              bullet="(4)"
              content={`적립금: 주문 시 사용하신 적립금은 환불 즉시 돌려드립니다.`}
            />
          </p>
        </div>
      </div>
    </>
  );
};

interface InfoItemProps {
  bullet: string;
  content: string;
  className?: string;
}

export const InfoItem: FC<InfoItemProps> = ({ bullet, content, className }) => {
  return (
    <>
      <div className={`${className} text-left flex space-x-2`}>
        <p className="">{bullet}</p>
        <p className="">{content}</p>
      </div>
    </>
  );
};
